import React from "react";
import "./GradientButton.css";

interface GradientButtonProps {
  text: string;
  onClick?: () => void;
  disabled?: boolean;
  svg?: React.ReactNode;
  bgColor?: string;
  textColor?: string; // <-- Add this line
  style?: React.CSSProperties;
}
const GradientButton: React.FC<GradientButtonProps> = ({
  text,
  onClick,
  disabled = false,
  svg,
  bgColor,
  textColor,
  style,
}) => {
  const btnStyle: React.CSSProperties = {
    ...style,
    background: bgColor,
    color: textColor,
  };

  return (
    <button
      className={`gradient-button${
        disabled ? " gradient-button--disabled" : ""
      }`}
      onClick={onClick}
      disabled={disabled}
      style={btnStyle}
    >
      {svg && <span className="gradient-button__icon">{svg}</span>}
      <span className="gradient-button__text">{text}</span>
    </button>
  );
};

export default GradientButton;
